module.exports = __webpack_public_path__ + "static/media/strive.e78e8661.jpg";